import { render } from "./ExcelReferencesTable.vue?vue&type=template&id=42bd98e2&scoped=true"
import script from "./ExcelReferencesTable.vue?vue&type=script&lang=js"
export * from "./ExcelReferencesTable.vue?vue&type=script&lang=js"

import "./ExcelReferencesTable.vue?vue&type=style&index=0&id=42bd98e2&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bd98e2"]])

export default __exports__